import type { LinkTilesProps } from '../types';
import LinkBlock from './LinkBlock';
import './Tile4Links.scss';

export default function Tile4Links({ tiles }: Pick<LinkTilesProps, 'tiles'>) {
    return (
        <div className="tile4-links">
            {tiles.map(linkBlock => (
                <LinkBlock {...linkBlock} key={linkBlock.sysId} />
            ))}
        </div>
    );
}
